import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, mergeProps as _mergeProps, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "detail_container"
}
const _hoisted_2 = { class: "detail_base-info card-white-6" }
const _hoisted_3 = { class: "detail_header" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "基本信息", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_7 = { class: "card-white-6 hw_detail_table_container" }
const _hoisted_8 = {
  key: 0,
  class: "card-white-6 hw_detail_table_container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_WeEditableWarp = _resolveComponent("WeEditableWarp")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_we_select = _resolveComponent("we-select")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_we_table = _resolveComponent("we-table")!
  const _component_FlowTimeLine = _resolveComponent("FlowTimeLine")!
  const _component_page_detail_wrapper = _resolveComponent("page-detail-wrapper")!

  return (_openBlock(), _createBlock(_component_page_detail_wrapper, _mergeProps({ title: _ctx.tracePage }, _ctx.$attrs, {
    collapsed: true,
    drop_down_menus: _ctx.get_drop_down_menus
  }), {
    default: _withCtx(() => [
      (_ctx.showRecharge)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("div", null, [
                  (_ctx.editMode)
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 0,
                        type: "primary",
                        onClick: _ctx.handleCancel
                      }, {
                        default: _withCtx(() => [
                          _hoisted_5
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true),
                  (_ctx.editMode)
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 1,
                        type: "primary",
                        onClick: _ctx.handleSave
                      }, {
                        default: _withCtx(() => [
                          _hoisted_6
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode(_component_a_form, {
                ref: "rechargeForm",
                model: _ctx.rechargeEdit,
                rules: _ctx.formRules
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_row, {
                    gutter: 20,
                    type: "flex",
                    style: {"flex-wrap":"wrap"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 8 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, {
                            label: "客户名称",
                            name: "rd_company_name"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_WeEditableWarp, {
                                value: _ctx.recharge.rd_company_name
                              }, {
                                text: _withCtx(() => [
                                  _createElementVNode("a", {
                                    type: "link",
                                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.jumpToCompany(_ctx.recharge.company_id))),
                                    style: {"white-space":"pre-wrap"}
                                  }, _toDisplayString(_ctx.recharge.rd_company_name), 1)
                                ]),
                                _: 1
                              }, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, { span: 8 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, {
                            label: "媒体平台",
                            name: "ad_platform",
                            rules: [_ctx.required()]
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_WeEditableWarp, {
                                value: _ctx.recharge.rd_ad_platform,
                                edit: _ctx.editMode
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_we_select, {
                                    value: _ctx.rechargeEdit.ad_platform,
                                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.rechargeEdit.ad_platform) = $event)),
                                    options: _ctx.getModelItems(_ctx.model.Recharge.AD_PLATFORM)
                                  }, null, 8, ["value", "options"])
                                ]),
                                _: 1
                              }, 8, ["value", "edit"])
                            ]),
                            _: 1
                          }, 8, ["rules"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, { span: 8 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, {
                            label: "充值类型",
                            name: "rd_property"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_WeEditableWarp, {
                                value: _ctx.recharge.rd_property
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, { span: 8 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, {
                            label: "充值金额",
                            name: "recharge_amount",
                            rules: [_ctx.required()]
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_WeEditableWarp, {
                                value: _ctx.formatMoneyByRound(_ctx.recharge.recharge_amount),
                                edit: _ctx.editMode
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_input, {
                                    value: _ctx.rechargeEdit.recharge_amount,
                                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.rechargeEdit.recharge_amount) = $event)),
                                    allowClear: ""
                                  }, null, 8, ["value"])
                                ]),
                                _: 1
                              }, 8, ["value", "edit"])
                            ]),
                            _: 1
                          }, 8, ["rules"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, { span: 8 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, {
                            label: "充值时间",
                            name: "recharge_time",
                            rules: [_ctx.required()]
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_WeEditableWarp, {
                                value: _ctx.formatTime(_ctx.recharge.recharge_time, 'YYYY-MM-DD'),
                                edit: _ctx.editMode
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_date_picker, {
                                    value: _ctx.rechargeEdit.recharge_time,
                                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.rechargeEdit.recharge_time) = $event)),
                                    allowClear: "",
                                    valueFormat: "YYYY-MM-DD",
                                    placeholder: "请选择"
                                  }, null, 8, ["value"])
                                ]),
                                _: 1
                              }, 8, ["value", "edit"])
                            ]),
                            _: 1
                          }, 8, ["rules"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, { span: 8 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, {
                            label: "创建人",
                            name: "rd_creator_name"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_WeEditableWarp, {
                                value: _ctx.recharge.rd_creator_name
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, { span: 8 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, {
                            label: "授信总额",
                            name: "rd_creator_name"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_WeEditableWarp, {
                                value: _ctx.formatMoneyByRound(_ctx.recharge.debt_info.credit_limit)
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, { span: 8 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, {
                            label: "授信余额",
                            name: "rd_creator_name"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_WeEditableWarp, {
                                value: _ctx.formatMoneyByRound(_ctx.recharge.debt_info.left_credit_limit)
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, { span: 8 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, { label: "逾期金额" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_WeEditableWarp, {
                                value: _ctx.formatMoneyByRound(_ctx.recharge.debt_info.to_collect_overdue)
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, { span: 8 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, { label: "逾期天数" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_WeEditableWarp, {
                                value: _ctx.recharge.debt_info.overdue_days + ' Days'
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model", "rules"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_we_table, _mergeProps(_ctx.contract_table_config, {
                dataSource: _ctx.recharge.contract_list
              }), {
                name: _withCtx(({ text, record }) => [
                  _createVNode(_component_a_button, {
                    type: "link",
                    onClick: ($event: any) => (_ctx.jumpToContract({ id: record.id }, true))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(text), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 1
              }, 16, ["dataSource"])
            ]),
            (!_ctx.isEmptyData(_ctx.recharge))
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  (!_ctx.isEmptyData(_ctx.recharge) && !_ctx.isEmptyData(_ctx.recharge.flow))
                    ? (_openBlock(), _createBlock(_component_FlowTimeLine, {
                        key: 0,
                        flow: _ctx.recharge.flow,
                        onOnCatchFlag: _ctx.catchFlowFlag,
                        onOnUpdate: _ctx.afterEditRecharge
                      }, null, 8, ["flow", "onOnCatchFlag", "onOnUpdate"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 16, ["title", "drop_down_menus"]))
}